import gql from "graphql-tag";
import {
  FRAGMENT_MEDIA_ITEM,
  FRAGMENT_NEIGHBORHOOD_DETAILS,
} from "./fragments.js";

export const GET_MODEL = gql`
  ${FRAGMENT_MEDIA_ITEM}
  ${FRAGMENT_NEIGHBORHOOD_DETAILS}
  query GetModel($uri: ID!) {
    collectionFeatures
    model(id: $uri, idType: URI) {
      databaseId
      id
      title
      collection {
        collection
        fieldGroupName
      }
      modelDetails {
        address1
        address2
        latitude
        longitude
        matterportTour
        matterportTourTitle
        virtualTour
        virtualTourMobile
        elevations {
          ...MediaItemFragment
        }
        floorplan {
          ... on Plan {
            databaseId
            id
            title
            uri
            floorplanDetails {
              planNotAvailable
              basePrice
              bathroomsMax
              bathroomsMin
              bedroomsMax
              bedroomsMin
              collection
              displayTitle
              finishedSqrFt
              garage
              garageMin
              garageType
              homeType
              mainSqrFt
              pdfEPub
              type
            }
          }
        }
        galleryItems {
          fieldGroupName
          type
          videoUrl
          image {
            ...MediaItemFragment
          }
        }
        neighborhood {
          ...NeighborhoodDetailsFragment
        }
      }
    }
    homes(last: 500) {
      nodes {
        databaseId
        slug
        title
        uri
        collection {
          collection
          fieldGroupName
        }
        qmiHomeDetails {
          address1
          address2
          city
          bathrooms
          bedrooms
          finishedSqrFt
          latitude
          longitude
          mainSqrFt
          price
          elevations {
            altText
            mediaDetails {
              sizes {
                file
                fileSize
                height
                mimeType
                name
                sourceUrl
                width
              }
            }
            sourceUrl
          }
          floorplan {
            ... on Plan {
              title
            }
          }
          model {
            ... on Model {
              databaseId
              id
              slug
              title
            }
          }  
        }
        productStatus {
          enableSnipeLink
          fieldGroupName
          sectionId
          statusCustom
          statusMessage
        }
      }
    }  
  }
`;
